import { render, staticRenderFns } from "./TrainingItem.vue?vue&type=template&id=fbc939aa&scoped=true&"
import script from "./TrainingItem.vue?vue&type=script&lang=js&"
export * from "./TrainingItem.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItem.vue?vue&type=style&index=0&id=fbc939aa&lang=scss&scoped=true&"
import style1 from "./TrainingItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc939aa",
  null
  
)

export default component.exports